import { ls } from './config.js';
import { isDefined } from './utilities.js';
import { dataObject } from './data-object.js';

const userSingleCoursesOverviewTableHeadings = [
	{ data: 'ID', title: 'ID' },
	{ data: 'course', title: reportingApiSetup.learnDashLabels.course },
	{ data: 'percentComplete', title: ls('% Complete') },
	{ data: 'completionDate', title: ls('Completion Date') },
	{
		data: 'avgQuizScore',
		title: sprintf(reportingApiSetup.localizedStrings.tablesColumnsAvgQuizScore, reportingApiSetup.learnDashLabels.quiz)
	},
	{ data: 'details', title: reportingApiSetup.localizedStrings.tablesColumnsDetails, className: 'no-sort' }
];

const userSingleCoursesOverviewTableData = function(userID) {
	var tableData = [];

	for (let courseID in dataObject.courseList) {
		if (typeof dataObject.userList.course_user_access_list[courseID] !== 'undefined' &&
			(typeof dataObject.userList.course_user_access_list[courseID][userID] !== 'undefined' || dataObject.courseList[courseID].course_price_type === 'open')) {

			var courseName = dataObject.courseList[courseID].post_title;

			if ('' === courseName) {
				courseName = sprintf(reportingApiSetup.localizedStrings.missingTitleCourseId, reportingApiSetup.learnDashLabels.course) + courseID;
			}

			let details = `<span class="reporting-table-see-details">${reportingApiSetup.localizedStrings.tablesButtonSeeDetails}</span>`;
			courseName = `<span class="reporting-table-see-details">${courseName}</span>`;

			let rowData = {
				ID: courseID,
				course: courseName,
				percentComplete: '',
				completionDate: '',
				avgQuizScore: '',
				details: details
			};

			tableData.push(rowData);
		}
	}

	return tableData;
};

export {
	userSingleCoursesOverviewTableHeadings,
	userSingleCoursesOverviewTableData
};
